var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('apexchart',{attrs:{"type":"bar","height":"500","options":_vm.config.chartOptions,"series":_vm.config.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }